import { Box, Skeleton, Stack } from '@mui/material'
import React from 'react'
import { Col, Row } from 'reactstrap'

const FormLoading = () => {
    return (
        <div >
            <Box>
                {/* Title */}
                <Skeleton variant="text" width="40%" height={25} />

                {/* Form fields */}
                <Stack spacing={2} mt={2}>
                    <Skeleton variant="rectangular" height={25} />
                    <Skeleton variant="rectangular" height={25} />
                    <Skeleton variant="rectangular" height={25} />
                    <Skeleton variant="rectangular" height={25} />
                    <Skeleton variant="rectangular" height={25} />
                    <Skeleton variant="rectangular" height={25} />
                    <Skeleton variant="rectangular" height={25} />
                </Stack>

                {/* Button */}
                <Row className="justify-content-between align-items-center mb-4">
                    <Col className="d-flex justify-content-start">
                        <Skeleton
                            variant="rectangular"
                            width={120}
                            height={40}
                            style={{ marginTop: "16px" }}
                        />
                    </Col>
                    <Col className="d-flex justify-content-end">
                        <Skeleton
                            variant="rectangular"
                            width={120}
                            height={40}
                            style={{ marginTop: "16px" }}
                        />
                    </Col>
                </Row>
            </Box>
        </div>
    )
}

export default FormLoading